import React, { ReactNode, useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import Dropdown, { DropdownItem } from './Dropdown';

export type Option = {
    [x: string]: any;
};

type Props = {
    selected: ReactNode;
    options: Option[];
    optionKey: string;
    open: boolean;
    activeDropdownKey?: Option | null;
    onChange: (option: Option, optionKey: string) => void;
    renderOption: (option: Option) => ReactNode;
    setOpen: (open: boolean) => void;
};

const Select: React.FC<Props> = ({
    selected,
    options,
    optionKey,
    open,
    activeDropdownKey,
    onChange,
    renderOption,
    setOpen,
}) => {
    const [active, setActive] = useState(options[0]);

    const showDropdown = () => setOpen(true);

    const closeDropdown = () => {
        if (!open) return;

        setOpen(false);
    };

    const handleOptionChange = (option: Option) => {
        onChange(option, optionKey);
        setActive(option);
        closeDropdown();
    };

    return (
        <ClickAwayListener onClickAway={closeDropdown}>
            <div className='select-custom'>
                <div className='selected-label' onClick={showDropdown}>
                    {selected}
                </div>
                <Dropdown open={open}>
                    {options.map((option, index) => {
                        return (
                            <DropdownItem
                                key={index}
                                active={
                                    activeDropdownKey
                                        ? activeDropdownKey[optionKey] ===
                                          option[optionKey]
                                        : active[optionKey] === option[optionKey]
                                }
                                onClick={() => handleOptionChange(option)}
                            >
                                {renderOption(option)}
                            </DropdownItem>
                        );
                    })}
                </Dropdown>
            </div>
        </ClickAwayListener>
    );
};

export default Select;
